import { useEffect, useState, useMemo, useCallback } from "react";
import { Col } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import Swal from "sweetalert2";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faPenToSquare,
  faTrash,
  faGraduationCap,
  faMagnifyingGlass
} from "@fortawesome/free-solid-svg-icons";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { PulseLoader } from "react-spinners";
import Pagination from "../../../../components/pagination_new";

export default function Jenjang() {
  document.title = "Jenjang";

  const [getData, setGetData] = useState([]);
  const ascending = 1;
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({query: "(max-width: 780px)"});

  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFetching, setIsFetching] = useState(false);

  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [id, setId] = useState();
  const [dataUpdate, setDataUpdate] = useState();

  const location = useLocation();
  const navigate = useNavigate();

  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  useEffect(() => {
    const storageLevel = localStorage.getItem("level");

    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (
      storageLevel === "developer" ||
      storageLevel === "superadmin"
    ) {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });

      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
      return;
    }

    setPermission({
      create: foundPermission.create,
      read: foundPermission.read,
      update: foundPermission.update,
      delete: foundPermission.delete,
    });
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const GetResponseData = useCallback(async () => {
    setSearchKeyword("");
    setTablePage(1);
    setIsFetching(true);

    try {
      const response = await APIMS.get(
        `/api/educational-stages?page=1&limit=1000&ascending=${ascending}&search=`,
        fetchParams
      );

      if (response?.status === 200) {
        setGetData(response?.data?.data || []);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error.response?.data?.message ||
          "Gagal memuat data",
      });
    } finally {
      setIsFetching(false);
    }
  }, [ascending, fetchParams]);

  useEffect(() => {
    GetResponseData();
  }, [GetResponseData]);

  const deleteById = async (id, name) => {
    Swal.fire({
      title: "Hapus data ini?",
      html: `<p class="sims-delete-description">Data <strong></strong> yang dihapus tidak dapat dikembalikan.</p>`,
      icon: "warning",
      customClass: {
        popup: "sims-delete-popup",
        icon: "sims-delete-icon",
        title: "sims-delete-title",
        actions: "sims-delete-actions",
        confirmButton: "sims-delete-confirm",
        cancelButton: "sims-delete-cancel",
        validationMessage: "sims-delete-validation",
      },
      buttonsStyling: false,
      showCancelButton: true,
      confirmButtonText: "Hapus data",
      cancelButtonText: "Batal",
      reverseButtons: true,
      focusCancel: true,

      didOpen: (popup) => {
        popup.querySelector(".sims-delete-description strong").textContent = name || "Jenjang";
      },
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const response = await APIMS.delete(
            `/api/educational-stages/${id}`,
            fetchParams
          );
  
          if (response.data.error) {
            throw new Error(response.data.message);
          }
  
          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error.response?.data?.message || "Gagal menghapus data"
          );
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ToastSuccess.fire({
          icon: "success",
          title: "Data berhasil dihapus",
        });
        GetResponseData();
      }
    });
  };

  const viewModalUpdate = (selectedId, jenjang) => {
    setId(selectedId);
    setDataUpdate(jenjang);
    setModalUpdate(true);
  };

  const nameCollator = useMemo(
    () =>
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      }),
    []
  );

  const filteredData = useMemo(() => {
    const keyword = String(searchKeyword || "")
      .trim()
      .toLowerCase();

    const rows = !keyword
      ? getData || []
      : (getData || []).filter((item) => {
          const searchableValues = [
            item?.stages,
            item?.stages_name,
            item?.seq,
            item?.min_grade,
            item?.max_grade,
          ];

          return searchableValues.some((value) =>
            String(value ?? "")
              .toLowerCase()
              .includes(keyword)
          );
        });

    return [...rows].sort((a, b) =>
      nameCollator.compare(
        String(a?.stages_name || "").trim(),
        String(b?.stages_name || "").trim()
      )
    );
  }, [getData, searchKeyword, nameCollator]);


  const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));

  useEffect(() => {
    setTablePage((page) => Math.min(page, totalPages));
  }, [totalPages]);


  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;

    return filteredData.slice(
      start,
      start + safeRows
    );
  }, [filteredData, tablePage, rowsPerPage]);


  return (
    <div className="body sims-page">
      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          id={id}
          dataUpdate={dataUpdate}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
        />
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon
                icon={faGraduationCap}
              />
            </span>

            <h4 className="page-title-text">
              Data Jenjang
            </h4>
          </div>

          <div className="ml-auto">
            <button
              type="button"
              onClick={() => setModalAdd(true)}
              className="btn btn-create sims-header-button"
            >
              <FontAwesomeIcon icon={faPlus} />
              <span>{isTabletOrMobile ? "Jenjang" : "Tambah Jenjang"}</span>
            </button>
          </div>

        </div>
      </div>

      <div className="body-content sims-content">
        {isFetching ? (
          <div className="sims-loading">
            <PulseLoader color="#3f5bea" size={12} />
          </div>
        ) : (
         <Col xl="12" sm="12" className="sims-column">
            <div className="sims-search-wrap mb-3">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="sims-search-icon"
              />

              <input
                type="text"
                className="sims-search-input"
                placeholder="Cari label atau nama jenjang..."
                value={searchKeyword}
                onChange={(event) => {
                  setSearchKeyword(event.target.value);
                  setTablePage(1);
                }}
              />
            </div>

            <div className="sims-table-card">
                <div className="sims-table-scroll">
                   <table className="sims-table">
                    <thead>
                      <tr>
                        <th className="sims-col-number">No</th>
                        <th style={{width: "130px"}}>Label</th>
                        <th>Nama Jenjang</th>
                        <th style={{ width: "150px", textAlign: "center"}} > Kelas Awal </th>
                        <th style={{ width: "150px", textAlign: "center"}} > Kelas Akhir </th>
                        <th className="sims-col-action">
                          Aksi
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {paginatedData.length > 0 ? (
                        paginatedData.map((row, index) => (
                            <tr key={row?.id || index}>
                              <td className="sims-col-number">
                                <span className="sims-number-badge">
                                  {(tablePage - 1) * rowsPerPage + index + 1}
                                </span>
                              </td>

                              <td>
                                <span className="sims-text-bold">
                                  {row?.stages || "-"}
                                </span>
                              </td>

                              <td>
                                <span className="sims-name-text">
                                  {row?.stages_name || "-"}
                                </span>
                              </td>

                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <span className="sims-muted-text">
                                  {row?.min_grade ?? "-"}
                                </span>
                              </td>

                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <span className="sims-muted-text">
                                  {row?.max_grade ?? "-"}
                                </span>
                              </td>

                              <td className="sims-col-action">
                                <div className="sims-action-wrap">
                                  <button
                                    type="button"
                                    className="sims-action-button sims-action-edit"
                                    title="Ubah jenjang"
                                    aria-label="Ubah jenjang"
                                    onClick={() => viewModalUpdate(row?.id, row )}
                                  >
                                    <FontAwesomeIcon
                                      icon={faPenToSquare}
                                    />
                                  </button>

                                  <button
                                    type="button"
                                    className="sims-action-button sims-action-delete"
                                    title="Hapus jenjang"
                                    aria-label="Hapus jenjang"
                                    onClick={() => deleteById(row?.id, row?.stages_name)}
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                  </div>
                                </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="sims-empty-state"
                          >
                            <div className="sims-empty-state-content">
                              Data jenjang tidak ditemukan
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  totalRows={filteredData.length}
                  tablePage={tablePage}
                  rowsPerPage={rowsPerPage}
                  onPageChange={setTablePage}
                  onRowsPerPageChange={(value) => {
                    setRowsPerPage(value);
                    setTablePage(1);
                  }}
                />
            </div>
          </Col>
        )}
      </div>
    </div>
  );
}